<template>
  <div class="container content-430">
    <div class="header-wrapper-430">
      <SearchBlock
        @on-search="handleSearch"
        @on-export="handleExport"
      ></SearchBlock>
      <div class="count flex justify-space_between align-items">
        <div>
          订单数：<span style="margin-right: 8px; font-weight: bold">{{
            count.orderNum
          }}</span>
          材料总额：<span style="margin-right: 8px; font-weight: bold">
            {{
              count.materialTotalAmount
                ? (Number(count.materialTotalAmount) / 100).toFixed(2)
                : '0.00'
            }}</span>
          取消订单数：<span style="margin-right: 8px; font-weight: bold">{{
            count.overOrderNum
          }}</span>
          全额退款数：<span style="margin-right: 8px; font-weight: bold">{{
            count.allRefundOrderNum
          }}</span>
          全额退款金额：<span style="margin-right: 8px; font-weight: bold">
            {{
              count.allRefundOrderAmount
                ? (Number(count.allRefundOrderAmount) / 100).toFixed(2)
                : '0.00'
            }}</span>
          已退款金额：<span style="margin-right: 8px; font-weight: bold">
            {{
              count.chargeFeeOrderAmount
                ? (Number(count.chargeFeeOrderAmount) / 100).toFixed(2)
                : '0.00'
            }}</span>（含全额、部分退款）
        </div>

        <Button type="primary" @click="handleExport">导出Excel</Button>
      </div>
    </div>

    <div class="table-main">
      <Table
        :columns="tableColumns"
        :data="tableData"
        border=""
        :loading="tableLoading"
        :max-height="tableHeight"
      >
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
        <template slot="orgName" slot-scope="{ row }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>
        <template slot="classroomName" slot-scope="{ row }">
          <TablePoptip :content="row.classroomName"> </TablePoptip>
        </template>
        <template slot="offerName" slot-scope="{ row }">
          <TablePoptip :content="row.offerName"> </TablePoptip>
        </template>

        <template slot="originalFee" slot-scope="{ row }">
          <span>
            {{
              row.originalFee
                ? (Number(row.originalFee) / 100).toFixed(2)
                : '--'
            }}
          </span>
        </template>
        <template slot="discFee" slot-scope="{ row }">
          <span>
            {{
              row.discFee
                ? (Number(row.discFee) / 100).toFixed(2)
                : '--'
            }}
          </span>
        </template>
        <template slot="offerFee" slot-scope="{ row }">
          <span>
            {{ row.offerFee ? (Number(row.offerFee) / 100).toFixed(2) : '--' }}
          </span>
        </template>
        <template slot="classroomFee" slot-scope="{ row }">
          <span>
            {{ row.classroomFee ? (Number(row.classroomFee) / 100).toFixed(2) : '--' }}
          </span>
        </template>
        <template slot="refundAmt" slot-scope="{ row }">
          <span>
            {{
              row.refundAmt ? (Number(row.refundAmt) / 100).toFixed(2) : '--'
            }}
          </span>
        </template>
        <template slot="channelType" slot-scope="{ row }">
          {{ channelTypeList[row.channelType - 1] }}
        </template>
        <template slot="payType" slot-scope="{ row }">
          {{ payTypeList[row.payType] }}
        </template>
        <template slot="paySts" slot-scope="{ row }">
          <span :class="getPayStsClassName(row.paySts)">{{
            payStsList[row.paySts]
          }}</span>
        </template>
        <template slot="refundSts" slot-scope="{ row }">
          <span :class="getRefundStsClassName(row.refundSts)">{{
            refundStsList[row.refundSts]
          }}</span>
        </template>
        <template slot="mainOrderId" slot-scope="{ row }">
          {{ row.mainOrderId == 0 ? '--' : row.mainOrderId }}
        </template>
        <template slot="refundCycleMethod" slot-scope="{ row }">
          <span v-if="row.payType==6||row.payType==7">{{ row.refundCycleMethod==1?'已结算':row.refundCycleMethod==2?'未结算' :'' }}</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <span
            v-if="
              row.paySts === 1 &&
                theUserIdentity !== 'edu' &&
                theUserIdentity !== 'org'
            "
            v-auth="`REFUND_SUBMIT`"
            class="red-color-430 m-16-430"
            @click="handleApplyRefund(row)"
          >申请退款</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        show-sizer
        show-total
        show-elevator
        :page-size-opts="pageSizeOpts"
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="onPageSizeChange"
      ></Page>
    </div>
    <RefundDrawerDetails
      ref="refundDetails"
      @refresh="getMaterialOrderPage"
    ></RefundDrawerDetails>
  </div>
</template>

<script>
import SearchBlock from './components/SearchBlock.vue';
import { getTableColumns } from './components/data/index';
import orderCenterApi from '@/request/orderCenter/index.js';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import RefundDrawerDetails from '@pv/orderCenter/assets/components/RefundDrawer/Details.vue'; // 退款详情抽屉
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
export default {
  name: 'OrderMaterialIndex',
  components: {
    SearchBlock,
    RefundDrawerDetails
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      tableLoading: false,
      tableColumns: getTableColumns(),
      tableData: [],
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      count: {
        orderNum: 0.00,
        materialTotalAmount: 0.00,
        overOrderNum: 0.00,
        allRefundOrderNum: 0.00,
        allRefundOrderAmount: 0.00,
        chargeFeeOrderAmount: 0.00
      },
      searchInfo: {},
      payStsList: {
        0: '待付款',
        1: '支付成功',
        2: '已关闭',
        8: '费用补缴'
      },
      refundStsList: ['未退款', '部分退款', '全额退款'],
      channelTypeList: ['管理后台', '微信小程序', '系统后台导入', ''],
      payTypeList: [
        '',
        '微信支付',
        '平安支付',
        '',
        '线下支付',
        '教师代付',
        '工行并笔支付',
        '工行单笔支付',
        '平安云支付'
      ]
    };
  },
  computed: { ...mapState(['theUserIdentity']), ...mapGetters(['routeTitle']) },
  activated() {
    this.getMaterialOrderPage();
    this.getMaterialOrderDataStatistics();
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('OrderMaterialIndex');
    next();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    async handleExport() {
      const parameter = this.getParameter();
      if (!this.checkParameter(parameter)) return null;

      delete parameter.pageNum;
      delete parameter.pageSize;
      const { ordTypes, ...params } = parameter;
      if (+ordTypes !== 0) {
        params.ordTypes = ordTypes;
      }
      this.$Spin.show();
      const res = await orderCenterApi.materialOrderExport({
        ...params

      });
      this.$Spin.hide();
      downLoadByBlob(res);
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getMaterialOrderPage();
    },
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getMaterialOrderPage();
    },
    handleSearch(info) {
      this.searchInfo = info;
      this.pageInfo.pageNum = 1;
      this.getMaterialOrderPage();
      this.getMaterialOrderDataStatistics();
    },
    checkParameter(parameter) {
      const reg = /^[0-9]{1,20}$/;
      const { orderOfferId, insOrderId, offerId } = parameter;
      if (orderOfferId && !reg.exec(orderOfferId)) {
        this.$Message.warning('请输入正确的订单编号');
        return false;
      }
      if (insOrderId && !reg.exec(insOrderId)) {
        this.$Message.warning('请输入正确的交易流水号');
        return false;
      }
      if (offerId && !reg.exec(offerId)) {
        this.$Message.warning('请输入正确的材料ID');
        return false;
      }
      return true;
    },
    getParameter() {
      const { pageNum, pageSize } = this.pageInfo;
      return {
        pageNum,
        pageSize,
        ...this.searchInfo
      };
    },
    async getMaterialOrderPage() {
      const parameter = this.getParameter();
      if (!this.checkParameter(parameter)) return null;
      this.tableLoading = true;
      const { ordTypes, ...params } = parameter;
      if (+ordTypes !== 0) {
        params.ordTypes = ordTypes.split(',');
      }
      const res = await orderCenterApi.getMaterialOrderPage(params);
      this.tableLoading = false;
      if (res.status == 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    async getMaterialOrderDataStatistics() {
      const parameter = this.getParameter();
      if (!this.checkParameter(parameter)) return null;
      const { ordTypes, ...params } = parameter;
      if (+ordTypes !== 0) {
        params.ordTypes = ordTypes.split(',');
      }
      const res = await orderCenterApi.getMaterialOrderDataStatistics(params);
      if (res.status == 200) {
        for (const k in this.count) {
          this.count[k] = res.message[k];
        }
        this.count = Object.assign({}, this.count);
      }
    },
    getRefundStsClassName(refundSts) {
      switch (Number(refundSts)) {
        case 2:
          return 'font-green';
          break;
        case 1:
          return 'click-color';
          break;
        default:
          return 'font-gray';
      }
    },
    getPayStsClassName(paySts) {
      switch (Number(paySts)) {
        case 0:
          return 'font-error';
          break;
        case 1:
          return 'font-green';
          break;
        case 2:
          return 'font-gray';
          break;
        case 3:
          return 'font-color';
          break;
        case 4:
          return 'font-error';
          break;
        case 8:
          return 'font-green';
          break;
        default:
          return 'font-gray';
      }
    },
    handleApplyRefund(row) {
      this.$nextTick(() => {
        this.$refs.refundDetails.openDetailsDrawer(row, 'apply');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.click-color {
  color: #488ffa;
  cursor: pointer;
}
.font-green {
  color: #19be6b;
}
.font-error {
  color: #ed4014;
}
.font-gray {
  color: #c5c8ce;
}
.font-orange {
  color: #ed8414;
}
.count {
  margin-bottom: 8px;
}
</style>
